export const CAMPAIGN_ID = {
    SHAHRVANDI: 10000,
    SHAHRVANDI_TICKET: 10007,
    MARKET_REGULATION: 10634,
}